module.exports = __webpack_public_path__ + "static/media/agent.20a1ce1b.svg";